/**
 * PaymentListContainer
 * --
 */
import React from 'react';
import PaymentListPresenter from './PaymentListPresenter';

const PaymentListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PaymentListPresenter />
    </>
  );
};

export default PaymentListContainer;
